import type { FC } from 'react';
import React from 'react';

import { URL_AGB, URL_DATENSCHUTZ } from '../utils/constants';

import Checkbox from './ui/Checkbox';

type TLegalVariant = 'order' | 'reminder';

interface ILegalCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  hasError?: boolean;
  variant?: TLegalVariant;
}

const LegalCheckbox: FC<ILegalCheckboxProps> = ({
  checked,
  onChange,
  hasError = false,
  variant = 'order'
}) => {
  const agbLink = <a href={URL_AGB} target="_top" rel="noreferrer">AGB</a>;
  const datenschutzLink = <a href={URL_DATENSCHUTZ} target="_top" rel="noreferrer">Datenschutzbestimmungen</a>;

  return (
    <Checkbox
      name="checkedLegal"
      checked={checked}
      onChange={onChange}
      hasError={hasError}
    >
      {variant === 'order' ? (
        <>
          Mit deiner Bestellung erklärst du dich mit unseren {agbLink}, {datenschutzLink}
          {' '}und der Widerrufsbelehrung einverstanden.
        </>
      ) : (
        <>
          Mit der Anmeldung erklärst du dich mit unseren {agbLink} und {datenschutzLink} einverstanden.
        </>
      )}
    </Checkbox>
  );
};

export default LegalCheckbox;
